import { useStore } from "../../lib/store";
import { isDemoMode } from "../../lib/supabase";
import { identityGate, type IdentityGate } from "./gate";

/**
 * Lê a porta de disponibilidade da identidade a partir do estado corrente.
 *
 * Fica separada de `gate.ts` para que a regra continue pura e testável sem o
 * store, e separada dos diálogos para que aquele arquivo exporte apenas
 * componentes.
 */
export function useIdentityGate(): IdentityGate {
  const store = useStore();
  return identityGate({
    foundationAvailable: store.identityFoundationAvailable,
    status: store.identityCapabilityStatus,
    canaryReady: Boolean(store.canonicalLeadCreationCanaryReady),
    demoMode: isDemoMode,
  });
}
